import React from 'react'
import { format } from 'date-fns'
import { RateRangeInputProps } from '../BulkShiftRateUpdateModal.types'

export const RateRangeInput: React.FC<RateRangeInputProps> = ({
  startDate,
  endDate,
  shiftCount,
  rateCardId,
  minRate,
  maxRate,
  currency,
  clientRate,
  value,
  onChange,
  error,
}) => {
  const formatCurrency = (amount: number | string) => {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency,
    }).format(numAmount)
  }

  const formattedStartDate = format(new Date(startDate), 'MMM d, yyyy')
  const formattedEndDate = endDate ? format(new Date(endDate), 'MMM d, yyyy') : 'Ongoing'
  const isFixedRateCard = minRate === maxRate

  return (
    <div style={{ marginBottom: '1rem', padding: '1rem', border: '1px solid #ddd', borderRadius: '4px' }}>
      <div
        style={{
          marginBottom: '0.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <strong>
          {formattedStartDate} - {formattedEndDate}
        </strong>
        <span
          style={{
            padding: '0.25rem 0.5rem',
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
            fontSize: '0.875rem',
          }}
        >
          {shiftCount} {shiftCount === 1 ? 'shift' : 'shifts'}
        </span>
      </div>

      <div style={{ marginBottom: '0.5rem' }}>
        <label htmlFor={`rate-${startDate}`} style={{ display: 'block', marginBottom: '0.25rem' }}>
          Client Rate
        </label>
        <input
          id={`rate-${startDate}`}
          type="number"
          min={minRate}
          max={maxRate}
          step={0.25}
          value={value}
          onChange={e => onChange(e.target.value)}
          readOnly={isFixedRateCard}
          style={{
            width: '100%',
            padding: '0.5rem',
            border: error ? '1px solid red' : '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: isFixedRateCard ? '#f5f5f5' : 'white',
            cursor: isFixedRateCard ? 'not-allowed' : 'text',
          }}
          placeholder={`Enter rate (${formatCurrency(minRate)} - ${formatCurrency(maxRate)})`}
        />
        {error && <div style={{ color: 'red', fontSize: '0.875rem', marginTop: '0.25rem' }}>{error}</div>}
      </div>

      <div style={{ fontSize: '0.875rem', color: '#666' }}>
        {isFixedRateCard ? (
          <span title="This is a fixed rate card - the rate cannot be changed">
            🔒 {formatCurrency(minRate)}
          </span>
        ) : (
          <>
            Valid range: {formatCurrency(minRate)} - {formatCurrency(maxRate)}
          </>
        )}
        <span style={{ marginLeft: '1rem', color: '#999' }}>Rate Card: {rateCardId}</span>
        <span style={{ marginLeft: '1rem', color: '#999' }}>Current Rate: {formatCurrency(clientRate)}</span>
      </div>
    </div>
  )
}
